// @mudrex/kyc and @mudrex/auth log auth headers; remove once they stop
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  (["log", "info", "debug", "warn", "error", "trace", "table", "dir"] as const).forEach(
    (method) => {
      console[method] = noop;
    }
  );
}

export {};
